<template>
  <CHeader position="sticky" class="bg-primary">
    <CContainer fluid class="gap-2 align-items-center flex-nowrap">
      <CHeaderBrand href="#/dashboard" class="text-white flex-shrink-0">
        <img class="app-brand" height="36" alt="Supia" :src="logo" />
      </CHeaderBrand>

      <AppNav class="d-none d-lg-flex" />

      <CHeaderNav class="ms-auto align-items-center flex-shrink-1 min-w-0 gap-2">
        <Notify v-if="tenant._key" :tenant="tenant" />
        <Account />
        <CButton class="app-customer text-truncate" @click="$emit('customers')">
          <CIcon :icon="tenant.name ? 'cil-building' : 'cil-globe-alt'" />
          <span class="ms-2 text-truncate">{{ label }}</span>
          <CIcon icon="cil-chevron-bottom" class="ms-2" size="sm" />
        </CButton>
      </CHeaderNav>
    </CContainer>
  </CHeader>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue'
import AppNav from '@/components/AppNav.vue'
import Account from '@/components/AppHeader/Dropdown/Account.vue'
import Notify from '@/components/AppHeader/Dropdown/Notify.vue'
import type { define as Tenant } from '@/components/tenant/interfaces'
import logo from '@/assets/images/logo.png'

export default defineComponent({
  name: 'AppHeader',
  components: { AppNav, Account, Notify },
  props: {
    tenant: {
      type: Object as PropType<Tenant>,
      required: true,
    },
  },
  emits: ['customers'],
  setup() {
    return { logo }
  },
  computed: {
    label(): string {
      return this.tenant.name ? this.tenant.name.toUpperCase() : 'ALL CUSTOMERS'
    },
  },
})
</script>

<style lang="scss">
// No colour variant: `btn-outline-light` turns white on hover and hides the white
// label, so every state is set through the button's custom properties.
.app-customer {
  --cui-btn-color: #fff;
  --cui-btn-bg: rgb(255 255 255 / 12%);
  --cui-btn-border-color: rgb(255 255 255 / 35%);
  --cui-btn-hover-color: #fff;
  --cui-btn-hover-bg: rgb(255 255 255 / 24%);
  --cui-btn-hover-border-color: rgb(255 255 255 / 60%);
  --cui-btn-active-color: #fff;
  --cui-btn-active-bg: rgb(255 255 255 / 30%);
  --cui-btn-active-border-color: rgb(255 255 255 / 75%);
  --cui-btn-focus-shadow-rgb: 255, 255, 255;

  min-width: 0;
  max-width: 18rem;
  flex: 0 1 auto;
  font-weight: 600;
  letter-spacing: 0.01em;
}

@media (max-width: 575.98px) {
  .app-brand {
    height: 24px;
  }

  // The header does not wrap: truncate the label rather than overflow the row.
  .app-customer {
    max-width: 34vw;
  }
}
</style>
